import { authedRequest } from './requests'
// *
 // *
 // * /subscriptions resource requests
 // *
export const postSubscription = (token, payload) =>{
  return (
    authedRequest('subscriptions/buy_subscription', token, {
      method: 'POST',
      body: JSON.stringify({
        plan_id: payload.planId,
        first_name: payload.firstname,
        last_name: payload.lastname,
        promocode: payload.promocode,
        phone: payload.phone,
        token: payload.token
      })
    })
)};



// WEBPACK FOOTER //
// ./src/utils/api/subscriptions.js